import Api from '@/servicesLocal/Api'
const path = 'regions'

export default {
    index(name,description, page) {
        return Api().get(path, {
            params: {
                name,
                description,
                page
            }
        })
    },
    show(id) {
        return Api().get(path + `/${id}`)
    },
    addUpdate(region) {
        return Api().post(path, region);
    },
    delete(id) {
        return Api().delete(path + `/${id}`)
    }
}